import React from "react";
import adaptation from '../imgs/icons8-adaptation-64.png'

import interactive from '../imgs/icons8-interactive-64.png'
import '../css/services.css'
import { useNavigate } from "react-router-dom";

export const Services = () => {

  const Navigate = useNavigate();
  
  const handleClick = () =>
  {
    Navigate('/pdfview')
  }
  const handleClick1 = () =>
    {
      Navigate('/web3')
    }


  return (
    <div>
    
    <div className="servicepage">
      <h3>SERVICES</h3>
    <div className="yellow-back">
      {/* <div className="services">
        <div className="logo-background"><img className="service-logo" alt="" src={conproduction} /></div>
        <p>Original Content </p><p> Production &</p>
        <p>Co-Production</p>
      </div> */}

      <div className="services" onClick={handleClick}>
        <div className="logo-background"><img className="service-logo" alt="" src={adaptation} /></div>
        <p>Adaptation &</p>
        <p>Remake Rights</p>
      </div>

      {/* <div className="services">
        <div className="logo-background"><img className="service-logo" alt="" src={conwriting} /></div>
        <p>Content Reselling &</p>
        <p> Cross Monetisation</p>
      </div> */}
   

    <div className="services" onClick={handleClick1}>
        <div className="logo-background"><img className="service-logo" alt="" src={interactive} /></div>
        <p>Web3-Verse</p>
        <p> Blockchain & NFT</p>
      </div>
    

    {/* <div className="services">
        <div className="logo-background"><img className="service-logo" alt="" src={referral} /></div>
        <p>Financial Assesent &</p>
        <p> Referral For Content Production</p>
      </div>
    

    <div className="services">
        <div className="logo-background"><img className="service-logo" alt="" src={digitalmarketing} /></div>
        <p>Digital Marketing &</p>
        <p>Content Placement</p>
      </div> */}

    </div>
    </div>

    
   
    </div>
  )

}